import React, { useState } from "react";
import cropr from "../shared/utils/cropr";
import FileUploadModal from "./FileUploadModal";
import FileOverviewCards from "./FileOverviewCards";
import gettext from "../shared/utils/gettext";
import { PermissionObject } from "./utils";
import Icon from "../shared/icons/Icon";

export interface SingleFileOverviewProps {
  attachmentId: string;
  permission: PermissionObject;
  onlyImages: Boolean;
  onChange: (obj: object | undefined) => void;
}
const SingleFileOverview = ({
  attachmentId,
  permission,
  onlyImages = false,
  onChange = () => {},
}: SingleFileOverviewProps) => {
  const [showModal, setShowModal] = useState(false);
  const [selectedObject, setSelectedObject] = useState<undefined | object>(() => {
    const allAttachments = cropr.documents.models.concat(cropr.images.models);
    return allAttachments.find((attachment) => attachmentId === String(attachment.get("id")));
  });
  const addAttachments = (selectedKeys: string[]) => {
    if (selectedKeys.length === 0) return removeAttachment();
    const selectedObject = cropr.documents.models
      .concat(cropr.images.models)
      .find((o) => selectedKeys[0] === o.get("key"));
    setSelectedObject(selectedObject);
    onChange(selectedObject);
  };
  const removeAttachment = () => {
    setSelectedObject(undefined);
    onChange(undefined);
  };
  return (
    <>
      <div className="row">
        <div className="controls col">
          {cropr.features.photo && permission.create && permission.update && (
            //maybe show 'BUY PRO' instead?
            <>
              {selectedObject ? (
                gettext("Attachment")
              ) : (
                <button
                  type="button"
                  className="btn btn-outline-green upload-btn"
                  onClick={() => setShowModal(true)}
                >
                  <Icon icon={"add-plus"} className={"pr-2"} />
                  {gettext("Attachment")}
                </button>
              )}
              <FileUploadModal
                attachments={selectedObject ? [selectedObject] : []}
                show={showModal}
                handleClose={() => setShowModal(false)}
                onChange={addAttachments}
                onlyImages={onlyImages}
                singleSelect={true}
              />
            </>
          )}
        </div>
      </div>
      <div className="img row">
        {selectedObject && permission.read ? (
          <div className="col-12">
            <FileOverviewCards
              attachmentList={selectedObject ? [selectedObject] : []}
              editable={permission.update}
              onClickRemove={removeAttachment}
              destroyable={false}
              onClickDestroy={() => null}
            />
          </div>
        ) : (
          <div className="col">
            <span>{gettext("No attachments")}</span>
          </div>
        )}
      </div>
    </>
  );
};

export default SingleFileOverview;
